module.exports = __webpack_public_path__ + "static/media/Pelin Arslan.06a4c5cb.png";